import { QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode } from 'react';

import { RefusalAnnouncer } from '@/components/composed/RefusalAnnouncer';
import { Toaster } from '@/components/composed/Toaster';
import { TooltipProvider } from '@/components/ui/tooltip';
import { queryClient } from './query-client';

/*
 * App-wide providers (spec §4.1). QueryClientProvider lives here (mounted from
 * __root). Toaster host, the global refusal live-region host (F03b R60
 * AC-8b85b662 — announces an attempted-and-refused act app-wide) and the
 * tooltip provider are global.
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>{children}</TooltipProvider>
      <Toaster />
      <RefusalAnnouncer />
    </QueryClientProvider>
  );
}
